/**
 * Feature-detect Brave.
 *
 * Deliberately NOT user-agent based: Brave reports itself as Chrome, which is
 * exactly why Brave-specific push failures arrive in Sentry tagged
 * `browser.name: Chrome` and why Brave's share of our users was unmeasurable.
 * `navigator.brave` is only defined on Brave, so a truthy check is a reliable
 * synchronous detect.
 *
 * Consumers: the `browser_brave` Sentry tag set at client init
 * (`SentrySetup.ts`) and the Brave-specific guidance in the push error state
 * (`NotificationSettings.tsx`). Keep this the single `navigator.brave`
 * definition in the codebase.
 */
export const isBrave = (): boolean =>
  typeof navigator !== 'undefined' &&
  Boolean((navigator as Navigator & { brave?: unknown }).brave);
